export const inr = (n) =>
  "\u20B9" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const inr0 = (n) =>
  "\u20B9" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

const TERMINAL_DONE = ["delivered", "completed", "picked_up", "on_the_way", "out_for_delivery", "dispatched", "in_transit"];
const TERMINAL_CANCEL = ["cancelled", "rejected", "canceled", "refunded", "failed"];
const NEW_STATUSES = ["placed", "pending", "confirmed", "paid", "new", "created", "payment_pending", "awaiting_vendor"];

export function bucketOf(o) {
  const s = (o.status || "").toLowerCase();
  if (TERMINAL_CANCEL.includes(s)) return "cancelled";
  if (TERMINAL_DONE.includes(s)) return "completed";
  if (s === "ready" || s === "ready_for_pickup") return "ready";
  if (s === "accepted" || s === "preparing") return "preparing";
  if (NEW_STATUSES.includes(s)) return "new";
  // Unknown/rider-driven status: an already-accepted order must NEVER resurface
  // as "new" (fixes picked-up orders re-appearing + firing new-order alerts).
  if (o.accepted_at) return "completed";
  return "new";
}

export const BUCKETS = ["new", "preparing", "ready", "completed", "cancelled"];
export const BUCKET_LABELS = {
  new: "New",
  preparing: "Preparing",
  ready: "Ready",
  completed: "Completed",
  cancelled: "Cancelled",
};

export function shortId(id) {
  if (!id) return "";
  return "#" + String(id).replace(/-/g, "").slice(0, 6).toUpperCase();
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = Math.floor((Date.now() - d.getTime()) / 1000);
  if (diff < 60) return diff + "s ago";
  if (diff < 3600) return Math.floor(diff / 60) + "m ago";
  if (diff < 86400) return Math.floor(diff / 3600) + "h ago";
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function itemCount(o) {
  return (o.items || []).reduce((a, i) => a + (i.quantity || 1), 0);
}

// Display label for an order item: append variant only if the name doesn't
// already include it (some orders store the variant in both name and variant).
export function itemLabel(it) {
  const name = (it.name || "").trim();
  const v = it.variant ? String(it.variant).trim() : "";
  if (v && !name.toLowerCase().includes(v.toLowerCase())) return `${name} (${v})`;
  return name;
}

// Aggregate non-cancelled orders in [from, to] -> { count, totalItems, sales, rows }.
// rows: [ [ "Item (Variant)", { qty, amount } ], ... ] sorted by qty desc.
export function summarizeOrders(orders, from, to) {
  const f = from.getTime();
  const t = to.getTime();
  const within = (orders || []).filter((o) => {
    if (!o.created_at) return false;
    const x = new Date(o.created_at).getTime();
    return x >= f && x <= t && bucketOf(o) !== "cancelled";
  });
  const map = new Map();
  let sales = 0;
  for (const o of within) {
    for (const it of o.items || []) {
      const q = Number(it.quantity) || 1;
      const p = Number(it.price) || 0;
      sales += p * q;
      const k = itemLabel(it);
      const c = map.get(k) || { qty: 0, amount: 0 };
      c.qty += q;
      c.amount += p * q;
      map.set(k, c);
    }
  }
  const rows = [...map.entries()].sort((a, b) => b[1].qty - a[1].qty);
  const totalItems = rows.reduce((s, [, v]) => s + v.qty, 0);
  return { count: within.length, totalItems, sales, rows };
}

export const mapsLink = (o) =>
  o?.latitude != null && o?.longitude != null
    ? `maps.google.com/?q=${Number(o.latitude).toFixed(6)},${Number(o.longitude).toFixed(6)}`
    : "";

